import { put, select, call, all } from 'redux-saga/effects';
import * as types from './personal-note.types';
import * as actions from './personal-note.actions';

import * as api from '../../api/request-config/personal-note.api';
import { personalNoteSelectors } from './personal-note.selectors';
import { apiRequest } from '../../api/api.saga-services';

export function* storePersonalNote(note: types.IPersonalNote) {
  yield put(actions.storePersonalNote(note));
  return note;
}

export function* clearPersonalNote(noteId: types.IPersonalNote['id']) {
  yield put(actions.clearPersonalNote(noteId));
}

export function* clearAllPersonalNotes() {
  const noteIds: types.IPersonalNote['id'][] = yield select(personalNoteSelectors.selectResourceIds);
  yield put(actions.clearPersonalNote(noteIds));
}

export function* searchPersonalNotes() {
  const notes: types.IPersonalNote[] = yield call(apiRequest, api.getPersonalNotesApi());
  if (!notes) {
    return [];
  }

  yield all(notes.map((note) => call(storePersonalNote, note)));
  return notes.map((note) => note.id);
}

export function* createPersonalNote() {
  const note = (yield call(apiRequest, api.createPersonalNoteApi())) as types.IPersonalNote;
  if (!note) {
    return;
  }
  yield call(storePersonalNote, note);
  return note;
}

export function* updatePersonalNote(noteId: types.IPersonalNote['id'], noteInfo: types.IPersonalNoteUpdate) {
  const note = (yield call(apiRequest, api.updatePersonalNoteApi(noteId, { ...noteInfo }))) as types.IPersonalNote;
  if (!note) {
    return;
  }
  yield call(storePersonalNote, note);
  return note;
}

export function* deletePersonalNote(noteId: types.IPersonalNote['id']) {
  yield call(apiRequest, api.deletePersonalNoteApi(noteId));
  yield call(clearPersonalNote, noteId);
}
